import { classicTemplate } from "./ClassicTemplate";
import { minimalTemplate } from "./MinimalTemplate";
import { splitTemplate } from "./SplitTemplate";
import type { CVTemplate, CVTemplateProps } from "./types";

/**
 * Registry of available CV templates, keyed by id. New templates (step 4+)
 * register here; nothing else in the render path needs to change.
 */
const TEMPLATES: Record<string, CVTemplate> = {
  [classicTemplate.id]: classicTemplate,
  [minimalTemplate.id]: minimalTemplate,
  [splitTemplate.id]: splitTemplate,
};

export const DEFAULT_TEMPLATE_ID = classicTemplate.id;

/** Lightweight list of available templates (id + display name) for pickers/UI. */
export const availableTemplates: { id: string; name: string }[] = Object.values(
  TEMPLATES,
).map(({ id, name }) => ({ id, name }));

interface TemplateRendererProps extends CVTemplateProps {
  /** Which template to render. Falls back to the classic template. */
  templateId?: string;
}

/**
 * TemplateRenderer — selects a template by id and renders it with the given
 * view model. This is the single entry point both `/p/:id` (screen) and
 * `/pdf/:id` (Puppeteer print) route through.
 */
export const TemplateRenderer = ({
  templateId,
  ...props
}: TemplateRendererProps) => {
  const template = TEMPLATES[templateId ?? DEFAULT_TEMPLATE_ID] ?? classicTemplate;
  const { Component } = template;
  return <Component {...props} />;
};

export { TEMPLATES };
